import { render, staticRenderFns } from "./tablePagination.vue?vue&type=template&id=2a1edf20&scoped=true"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"
import style0 from "./tablePagination.vue?vue&type=style&index=0&id=2a1edf20&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1edf20",
  null
  
)

export default component.exports